<template>
  <Modal
    :width="width"
    :title="modalTitle"
    :value="isVisible"
    footer-hide
    @on-visible-change="onModalVisibleChange"
  >
    <QueryTable
      :results="tableData"
      :is-loading="isLoading"
      share-mode
    />
  </Modal>
</template>
<script>
import QueryTable from './QueryTable'

export default {
  components: {
    QueryTable
  },

  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: String,
    visible: Boolean,
    width: {
      type: Number,
      default: () => 1200
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      isVisible: this.visible,
      tableData: this.data,
      isLoading: this.loading,
      modalTitle: this.title
    }
  },

  watch: {
    visible (newVisible) {
      this.isVisible = newVisible
    },

    title (newTitle) {
      this.modalTitle = newTitle
    },

    data (newData) {
      this.tableData = newData
    },

    loading (newLoading) {
      this.isLoading = newLoading
    }
  },

  methods: {
    /**
     * Emitted when modal changes visibility
     * @param {Boolean} visible - true if modal is now visible
     */
    onModalVisibleChange (visible) {
      this.$emit('change', visible)
    }
  }
}
</script>
